<script setup lang="ts">
import { VSkeletonBar } from '@/modules/shared/components'

withDefaults(defineProps<{ rows?: number }>(), { rows: 4 })
</script>

<template>
  <div aria-hidden="true" class="flex flex-col gap-5">
    <div class="flex items-end justify-between">
      <div class="flex flex-col gap-2">
        <VSkeletonBar width="112px" height="30px" />
        <VSkeletonBar width="56px" />
      </div>
      <div class="flex flex-col items-end gap-2">
        <VSkeletonBar width="96px" height="24px" />
        <VSkeletonBar width="72px" />
      </div>
    </div>

    <VSkeletonBar width="100%" height="14px" />

    <div class="flex flex-col gap-3 border-t border-[var(--divider-color,#EEEFF0)] pt-3">
      <div v-for="row in rows" :key="row" class="flex items-center gap-3">
        <div class="h-9 w-9 flex-shrink-0 animate-pulse rounded-full bg-gray-200"></div>
        <div class="flex flex-1 flex-col gap-1.5">
          <VSkeletonBar width="40%" />
          <VSkeletonBar width="60%" />
        </div>
        <VSkeletonBar width="64px" />
      </div>
    </div>
  </div>
</template>
